// src/client/pages/not-found.tsx
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@client/components/ui/card";
import { Button } from "@client/components/ui/button";
import { AlertCircle, Home, ArrowLeft } from "lucide-react";
import type { NotFoundPageProps } from '@client/types';

// ============================================================================
// Main NotFound Component
// ============================================================================

export default function NotFound(_props: NotFoundPageProps) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center space-y-2">
          <div className="flex justify-center mb-2">
            <div className="p-3 bg-red-100 rounded-full">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            404 - Page Not Found
          </CardTitle>
          <CardDescription className="text-gray-600">
            The page you're looking for doesn't exist
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <p className="text-sm text-blue-800">
              <strong>Developer Note:</strong> Did you forget to add this route to the router configuration?
            </p>
          </div>

          <div className="space-y-2">
            <p className="text-sm text-gray-600">
              Here are some helpful links:
            </p>
            <ul className="text-sm text-gray-600 list-disc list-inside space-y-1 pl-2">
              <li>Dashboard</li>
              <li>Users Management</li>
              <li>Database Admin</li>
              <li>Settings</li>
            </ul>
          </div>

          <div className="flex gap-2 pt-2">
            <Button 
              variant="outline" 
              onClick={handleGoBack}
              className="flex-1"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
            <Button 
              onClick={handleGoHome}
              className="flex-1"
            >
              <Home className="mr-2 h-4 w-4" />
              Go Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}